import moment from 'moment';
import { xfsb } from 'utils/utils';
import validator from 'validator';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { getDataType } = ssCommonUtils;

export const REST = {
    STATUS: {
        NONE: 'none',
        PENDING: 'pending',
        SUCCESS: 'success',
        FAILURE: 'failure'
    }
}

export const AFSP = {
    POPULATION: 'AFSP',
    ORIGINATING_SYSTEM: 'AFSP_Home-Service',
    ROLES: {
        CANDIDATE: 'CANDIDATE',
        PROVIDER: 'PROVIDER_ADMIN'
    },
    TYPE: {
        REGISTRATION: 'afsp-registration',
        PROVIDER_REGISTRATION: 'afsp-provider-registration',
        LOGIN: 'afsp-login',
        CHECK: 'afsp-check-user',
        PASSWORD_RESET_REQUEST: 'afsp-password-reset-request',
        PASSWORD_RESET: 'afsp-password-reset',
        POST_CAPTCHA: 'afsp-post-captcha',
        GET_CAPTCHA: 'afsp-get-captcha'
    },
    CHECK_TYPE: {
        EMAIL: 'EMAIL',
        USERNAME: 'USERNAME'
    },
    CONTACT_TYPE: {
        EMAIL: 'EMAIL',
        PHONE: 'PHONE_NUMBER'
    },
    ENDPOINTS: {
        REGISTER_USER: '/user',
        LOGIN_USER: '/login',
        USER_CHECK: '/user/check',
        USER_RESET: '/user/reset',
        CAPTCHA: '/session/captcha'
    }
}

function scrubEmptyStrings(d) {
    var iterator = (o) => {
        var obj = {};
        for (var p in o) {
            switch (getDataType(o[p])) {
                case 'Object':
                    obj[p] = iterator(o[p]);
                    break;
                case 'String':
                    if (o[p] === '') o[p] = null;
                    obj[p] = o[p];
                    break;
                default:
                    obj[p] = o[p];
            }
        }
        return obj;
    };
    return iterator(d);
}

// [NOTE]
// These are all the props according to the API doc
// that I used to generate these objects.

var
checkUser = {
    timestamp: null,
    originatingSystem: AFSP.ORIGINATING_SYSTEM,
    messageUuid: null,
    checkType: null,
    checkValue: null
},
resetUserPassword = {
    timeStamp: null,
    originatingSystem: AFSP.ORIGINATING_SYSTEM,
    messageUuid: null,
    id: null, // Can be email or username
    type: null, // EMAIL || USERNAME
    password: null,
    captcha: null
},
registration = {
    timeStamp: null,
    originatingSystem: AFSP.ORIGINATING_SYSTEM,
    messageUuid: null,
    ssUser: {
        userName: null,
        password: null,
        personalInformation: {
            firstName: null,
            middleName: null,
            lastName: null,
            nameSuffix: null,
            dateOfBirth: null,
            dateOfBirthType: null,
            passportType: null,
            passportNumber: null,
            expirationDate: null,
            issuingCountry: null,
            city: null,
            issuedOutOfCountry: null, // WILL BE REMOVED
            hasBeenRenewed: null // WILL BE REMOVED
        },
        organizationInformation: {
            fsdo: null,
            trainingProviderName: null,
            trainingProviderState: null,
            trainingProviderType: null,
            faaCertificationOrSatelliteDesignator: null
        },
        userRoles: [],
        contactInformation: [],
        securityQuestions: []
    }
};

export function generateRequestObject(r, d) {
    const {POPULATION, ENDPOINTS, CONTACT_TYPE, ROLES} = AFSP;

    if (r != null && r !== '') {
        switch (r) {
            case AFSP.TYPE.POST_CAPTCHA:
                return {
                    method: 'POST',
                    endpoint: `${ENDPOINTS.CAPTCHA}/${d}`,
                    headers: { 'Content-Type': 'application/json' }
                }

            case AFSP.TYPE.GET_CAPTCHA:
                return {
                    method: 'GET',
                    endpoint: ENDPOINTS.CAPTCHA,
                    headers: { 'Content-Type': 'application/json' }
                };

            case AFSP.TYPE.LOGIN:
                const { userId, password } = d.login;
                return {
                    method: 'POST',
                    endpoint: ENDPOINTS.LOGIN_USER,
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded;' },
                    body: xfsb({
                        username: userId.value,
                        password: password.value
                    })
                };

            case AFSP.TYPE.CHECK:
                const { type, value, help, stateReference } = d;
                return {
                    meta: {
                        ref: stateReference,
                        help: help
                    },
                    request: {
                        method: 'POST',
                        endpoint: ENDPOINTS.USER_CHECK,
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({...checkUser,
                            timestamp: moment.utc().unix(),
                            messageUuid: 'e60299b0-e039-4a05-bb58-ea49e6795b81',
                            checkType: type,
                            checkValue: value
                        })
                    }
                };

            case AFSP.TYPE.REGISTRATION:
                const { email, passport, personal, security, signature } = d;
                return {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    endpoint: ENDPOINTS.REGISTER_USER,
                    body: JSON.stringify(scrubEmptyStrings({...registration,
                        timeStamp: moment.utc().unix(),
                        messageUuid: '9dc02909-7597-4faf-a939-788c177d3f3a',
                        ssUser: {...registration.ssUser,
                            userName: email.userId,
                            password: '',
                            population: POPULATION,
                            personalInformation: {...registration.ssUser.personalInformation,
                                firstName: personal.firstName,
                                middleName: personal.middleName,
                                lastName: personal.lastName,
                                nameSuffix: personal.nameSuffix,
                                dateOfBirth: personal.dob,
                                dateOfBirthType: personal.dobType,
                                passportNumber: passport.passportNumber,
                                passportType: passport.passportType,
                                expirationDate: passport.expirationDate,
                                passportIssueDate: passport.issueDate,
                                issuingCountry: passport.issuingCountry,
                                city: passport.city
                            },
                            userRoles: [{
                                role: ROLES.CANDIDATE,
                                population: POPULATION
                            }],
                            contactInformation: [{
                                contactValue: email.emailAddress,
                                contactType: CONTACT_TYPE.EMAIL
                            }, {
                                contactValue: personal.phoneNumber,
                                contactType: CONTACT_TYPE.PHONE
                            }],
                            securityQuestions: [{
                                securityQuestionId: 1,
                                securityQuestionAnswer: security.q1
                            }, {
                                securityQuestionId: 2,
                                securityQuestionAnswer: security.q2
                            }, {
                                securityQuestionId: 3,
                                securityQuestionAnswer: security.q3
                            }]
                        }
                    }))
                };

            case AFSP.TYPE.PROVIDER_REGISTRATION:
                return {
                    method: 'POST',
                    endpoint: ENDPOINTS.REGISTER_USER,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(scrubEmptyStrings({...registration,
                        timeStamp: moment.utc().unix(),
                        messageUuid: '9dc02909-7597-4faf-a939-788c177d3f3a',
                        ssUser: {...registration.ssUser,
                            password: '',
                            personalInformation: {...registration.ssUser.personalInformation,
                                firstName: d.firstName,
                                middleName: d.middleName,
                                lastName: d.lastName
                            },
                            organizationInformation: {...registration.ssUser.organizationInformation,
                                fsdo: d.fsdo,
                                trainingProviderName: d.schoolName,
                                trainingProviderState: d.schoolState,
                                trainingProviderType: d.schoolType,
                                faaCertificationOrSatelliteDesignator: d.faaCert
                            },
                            userRoles: [{
                                role: ROLES.PROVIDER,
                                population: POPULATION
                            }],
                            contactInformation: [{
                                contactValue: d.emailAddress,
                                contactType: CONTACT_TYPE.EMAIL
                            }, {
                                contactValue: d.phoneNumber,
                                contactType: CONTACT_TYPE.PHONE
                            }]
                        }
                    }))
                };

            case AFSP.TYPE.PASSWORD_RESET_REQUEST:
                const { forgotten } = d;
                return {
                    method: 'POST',
                    endpoint: ENDPOINTS.USER_RESET,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({...resetUserPassword,
                        timeStamp: moment.utc().unix(),
                        messageUuid: 'e60299b0-e039-4a05-bb58-ea49e6795b81',
                        id: forgotten.userId.value,
                        type: validator.isEmail(forgotten.userId.value) ? 'EMAIL' : 'USERNAME',
                        captcha: 'abc123'
                    })
                };

            case AFSP.TYPE.PASSWORD_RESET:
                return {
                    method: 'PUT',
                    endpoint: ENDPOINTS.USER_RESET,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({...resetUserPassword,
                        timeStamp: moment.utc().unix(),
                        messageUuid: 'e60299b0-e039-4a05-bb58-ea49e6795b81',
                        id: d.id,
                        captcha: d.captcha,
                        password: d.password
                    })
                }
            default: return d;
        }
    } else return { error: {
        msg: 'No \'req\' property found in argument. Failed to request.'
    }};
}
export function submitProviderRegistration(d, captcha) {
    const {POPULATION, ENDPOINTS, CONTACT_TYPE, ROLES} = AFSP;
        return {
            method: 'POST',
            endpoint: ENDPOINTS.REGISTER_USER,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(scrubEmptyStrings({...registration,
                timeStamp: moment.utc().unix(),
                messageUuid: '9dc02909-7597-4faf-a939-788c177d3f3a',
                ssUser: {...registration.ssUser,
                    password: '',
                    captcha: captcha,
                    personalInformation: {...registration.ssUser.personalInformation,
                        firstName: d.firstName,
                        middleName: d.middleName,
                        lastName: d.lastName
                    },
                    organizationInformation: {...registration.ssUser.organizationInformation,
                        fsdo: d.fsdo,
                        trainingProviderName: d.schoolName,
                        trainingProviderState: d.schoolState,
                        trainingProviderType: d.schoolType,
                        faaCertificationOrSatelliteDesignator: d.faaCert
                    },
                    userRoles: [{
                        role: ROLES.PROVIDER,
                        population: POPULATION
                    }],
                    contactInformation: [{
                        contactValue: d.emailAddress,
                        contactType: CONTACT_TYPE.EMAIL
                    }, {
                        contactValue: d.phoneNumber,
                        contactType: CONTACT_TYPE.PHONE
                    }]
                }
            }))
        };
}